module.exports = __webpack_public_path__ + "ed323e7a3f115f4fc52b2641d95f54fd.png";